<template>
  <v-dialog :model-value="dialog" max-width="500">
    <v-card color="white">
      <v-card-title class="sugges-title">{{
        $t('profileForm.suggestDisciplineForm.title')
      }}</v-card-title>

      <v-btn
        @click="() => handleClose()"
        color="#007058"
        size="small"
        style="position: absolute; right: 10px; top: 15px"
        variant="outlined"
        density="compact"
        icon="$close"
      ></v-btn>

      <v-card-text>
        <p class="mb-5 text-center">
          {{ $t('profileForm.suggestDisciplineForm.description') }}
        </p>

        <div>
          <label>{{
            $t('profileForm.suggestDisciplineForm.discipline.label')
          }}</label>
          <v-text-field
            class=""
            density="compact"
            rounded="lg"
            ref="discipline"
            v-model="form.discipline.value"
            :rules="form.discipline.rules"
            :error-messages="form.discipline.error"
            :placeholder="$t('profileForm.suggestDisciplineForm.placeholder')"
          ></v-text-field>
          <!-- <template v-else>
            <p class="text-secondary">
              {{ $t('profileForm.suggestDisciplineForm.successMessage') }}
            </p>
          </template> -->
        </div>

        <div class="d-flex ga-2 w-100 mt-2">
          <v-btn
            class="w-50"
            style="color: #757575; font-weight: 700"
            color="#E0E0E0"
            variant="flat"
            :text="
              finished
                ? $t('commonDialog.closeBtn')
                : $t('confirmDialog.cancelBtn')
            "
            @click="handleClose"
          >
          </v-btn>
          <v-btn
            v-if="!finished"
            class="w-50"
            color="secondary"
            variant="flat"
            :text="$t('profileForm.suggestDisciplineForm.submitBtn')"
            :loading="submitLoading"
            @click="() => handleSubmit()"
          >
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import createHttpClient from '@/api/httpClient'
import MessageService from '@/components/feedback/message/messageService'

const { t } = useI18n()
const discipline = ref(null)
const submitLoading = ref(false)
const finished = ref(false)

defineProps({
  dialog: Boolean,
})
const emit = defineEmits(['update:dialog'])

const form = ref({
  discipline: {
    value: '',
    error: '',
    rules: [
      (v: string) =>
        !!v || t('profileForm.suggestDisciplineForm.discipline.error.required'),
    ],
  },
})

const handleSubmit = () => {
  discipline.value?.validate()
  if (!form.value.discipline.value) {
    return
  }
  const client = createHttpClient('/discipline')
  submitLoading.value = true
  client
    .post('/suggest', {
      name: form.value.discipline.value,
    })
    .then(() => {
      emit('update:dialog', false)
      form.value.discipline.value = ''
      MessageService.success(
        t('profileForm.suggestDisciplineForm.successMessage'),
      )
    })
    .catch(response => {
      if (response.data?.message) {
        form.value.discipline.error = response.data.message
      }
    })
    .finally(() => {
      submitLoading.value = false
    })
}

const handleClose = () => {
  form.value.discipline.value = ''
  form.value.discipline.error = ''
  finished.value = false
  emit('update:dialog', false)
}
</script>

<style scoped lang="scss">
.sugges-title {
  background-color: #0299781a;
  color: #007058;
  font-weight: 600;
  font-size: 23px;
  letter-spacing: -0.92px;
  text-align: center;
}
</style>
